import React from 'react';
import clsx from 'clsx';

import { Color } from 'types/colors';

import css from './IndicatorDot.module.scss';

interface Props {
    color?: Color;
}

const IndicatorDot: React.FC<Props> = ({ color = 'green' }) => (
    <div className={clsx(css.indicator, color && css[color])} />
);

export default IndicatorDot;
